import { call, put, takeLatest } from "redux-saga/effects";
import {
  billValidationRequested,
  billValidationSucceeded,
  billValidationFailed,
} from "./billValidationSlice";
import {
  BillValidationPayload,
  BillValidationResult,
} from "features/bbps/biller/billerFlowTypes";
import { validateBillService } from "services/api.services/biller/billerService";
import { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";

function* handleBillValidation(action: {
  type: string;
  payload: BillValidationPayload;
}) {
  try {
    const result: BillValidationResult = yield call(
      validateBillService,
      action.payload,
    );

    // yaha result.reason.responseCode check kar sakte ho
    if (result.reason?.responseReason !== "Successful") {
      const err: NormalizedError = {
        status: 422,
        message: result.reason?.responseReason || "Validation failed.",
        code: result.reason?.responseCode,
        url: "",
        method: "POST",
        raw: result,
      };
      yield put(billValidationFailed(err));
      return;
    }

    yield put(billValidationSucceeded(result));
  } catch (err: any) {
    const normalized: NormalizedError = err;
    yield put(billValidationFailed(normalized));
  }
}

export function* billValidationWatcher() {
  // console.log("billValidationRequested in saga:", billValidationRequested);

  yield takeLatest(billValidationRequested.type, handleBillValidation);
}
